export default {"src":"/images/4.jpg","width":3411,"height":4600,"aspectRatio":0.7415217391304347};